import {initIngredientsSwiper} from "../swiper/swiper";

const HOW_CLASS   = 'product-ingredients';
const HOW_DATA    = 'data-product-ingredients';
const LIGHT_MOD   = `${HOW_CLASS}--light`;                   // модификатор для светлого фона
const ACTIVE_WRAP = `${HOW_CLASS}__wrap--active`;
const ACTIVE_NAV  = `${HOW_CLASS}__nav-item--active`;

/* -------------------------------------------------------------------------- */
/* 1. Инициализация блока                                                     */
/* -------------------------------------------------------------------------- */
document.querySelectorAll(`[${HOW_DATA}]`).forEach(initIngredients);

function initIngredients(root) {
    initTabs(root);



    const swiperEl = root.querySelector(`[${HOW_DATA}-swiper] .swiper-wrapper`);
    if (swiperEl && swiperEl.children.length > 1) {
        initIngredientsSwiper(`${HOW_CLASS}__swiper`);
    }
}

/* -------------------------------------------------------------------------- */
/* 2. Переключение вкладок                                                    */
/* -------------------------------------------------------------------------- */
function initTabs(root) {
    const navItems = root.querySelectorAll(`[${HOW_DATA}-nav]`);
    if (navItems.length < 2) return;       // нет переключателей ‑ выходим

    const wraps = root.querySelectorAll('[data-wrap]');

    navItems.forEach(item => {
        item.addEventListener('click', () => {
            const id = item.getAttribute(`${HOW_DATA}-nav`);
            navItems.forEach(el => el.classList.remove(ACTIVE_NAV));
            wraps.forEach(el => el.classList.remove(ACTIVE_WRAP));

            item.classList.add(ACTIVE_NAV);
            root.querySelector(`[data-wrap="${id}"]`)?.classList.add(ACTIVE_WRAP);
        });
    });
}


